var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"-1cDxJEGKh8Cax7x_Vz6G"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["ambassador@abillion"]={id:"-1cDxJEGKh8Cax7x_Vz6G"};
      